import {ACTIVITIES_URL} from "@api/doinsport/services/activity/activity.api";

const KIDS_ACTIVITY = `${ACTIVITIES_URL}/f43e75cf-d790-4fa6-97a7-3539823a45fe`
const BIRTHDAY_ACTIVITY = `${ACTIVITIES_URL}/56743a8a-b1a0-4f5d-9f93-203852d544a0`

export const EXCLUDED_ACTIVITIES = [KIDS_ACTIVITY, BIRTHDAY_ACTIVITY];
